import { graphql } from 'graphql-relay';

export default graphql`
  query ProductCatalog_Query(
    $count: Int
    $category: String
    $sortBy: String
    $filterPrice: [String]
    $filterByCause: [String]
    $filterByType: [String]
    $filterByVarietal: [String]
    $filterByGiftCategories: [String]
    $productCategories: [String]
    $productsExclude: [String]
    $productsOnly: [String]
  ) {
    viewer {
      id
      id
      ...ProductsCatalog_viewer
        @arguments(
          count: $count
          category: $category
          sortBy: $sortBy
          filterPrice: $filterPrice
          filterByCause: $filterByCause
          filterByType: $filterByType
          filterByVarietal: $filterByVarietal
          filterByGiftCategories: $filterByGiftCategories
          productCategories: $productCategories
          productsExclude: $productsExclude
          productsOnly: $productsOnly
        )
    }
  }
`;
